import { sleep } from "@/lib/utils";

import type { Api, Cart } from "../types";

const photo = (id: string) =>
	`https://images.unsplash.com/photo-${id}?w=200&h=260&fit=crop&q=80&fm=jpg&auto=format`;

// Active (un-checked-out) carts for the admin Carts tab — useful for spotting
// abandoned baskets. Mirrors the gateway's hydrated Cart shape.
const fixtures: Cart[] = [
	{
		id: "cart_a1b2c3d4e5f6",
		items: [
			{
				id: "ci_1",
				productId: "prod-6",
				shopId: "shop-lina",
				name: "Льняное платье «Прованс»",
				brand: "Мастерская Лины",
				photo: photo("1595777457583-95e059d581b8"),
				size: "M",
				color: "Голубой",
				qty: 1,
				unitPrice: 8900,
				lineTotal: 8900,
				stock: 5,
				available: true,
			},
			{
				id: "ci_2",
				productId: "prod-24",
				shopId: "shop-natur",
				name: "Шерстяные носки с узором",
				brand: "НатурТекстиль",
				photo: photo("1605034313761-73ea4a0cfbf3"),
				size: "39-41",
				color: "Красный",
				qty: 2,
				unitPrice: 680,
				lineTotal: 1360,
				stock: 80,
				available: true,
			},
		],
		itemCount: 3,
		subtotal: 10260,
		updatedAt: "2026-05-25T20:11:00Z",
	},
	{
		id: "cart_9z8y7x6w5v4u",
		items: [
			{
				id: "ci_3",
				productId: "prod-16",
				shopId: "shop-silver-moon",
				name: "Браслет из натуральных камней",
				brand: "Silver Moon",
				photo: photo("1611652022419-a9419f74343d"),
				size: "18 см",
				color: "Зелёный",
				qty: 1,
				unitPrice: 2200,
				lineTotal: 2200,
				stock: 7,
				available: true,
			},
		],
		itemCount: 1,
		subtotal: 2200,
		updatedAt: "2026-05-26T08:47:00Z",
	},
];

export const carts: Api["carts"] = {
	async list() {
		await sleep(140);
		return [...fixtures].sort((a, b) => (a.updatedAt < b.updatedAt ? 1 : -1));
	},
};
